import { render, staticRenderFns } from "./site.vue.html?vue&type=template&id=52fb9389"
import script from "./site.controller.ts?vue&type=script&lang=js&external"
export * from "./site.controller.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports